const API_BASE = "/api/vat";

export interface HmrcAuthStatus {
  configured: boolean;
  authenticated: boolean;
}

export interface HmrcAuthUrl {
  url: string;
}

export interface VatObligation {
  start: string;
  end: string;
  due: string;
  status: string;
  periodKey: string;
  received: string | null;
}

export interface VatReturnReq {
  periodKey: string;
  vatDueSales: number;
  vatDueAcquisitions: number;
  totalVatDue: number;
  vatReclaimedCurrPeriod: number;
  netVatDue: number;
  totalValueSalesExVAT: number;
  totalValuePurchasesExVAT: number;
  totalValueGoodsSuppliedExVAT: number;
  totalAcquisitionsExVAT: number;
  finalised: boolean;
}

export const hmrcVatApi = {
  async getStatus(): Promise<HmrcAuthStatus> {
    const res = await fetch(`${API_BASE}/status`);
    if (!res.ok) throw new Error("Failed to check HMRC status");
    return res.json();
  },

  async getAuthUrl(): Promise<HmrcAuthUrl> {
    const res = await fetch(`${API_BASE}/auth-url`);
    if (!res.ok) throw new Error("Failed to get auth URL");
    return res.json();
  },

  async setToken(accessToken: string): Promise<{ ok: boolean }> {
    const res = await fetch(`${API_BASE}/set-token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ access_token: accessToken }),
    });
    if (!res.ok) throw new Error("Failed to set token");
    return res.json();
  },

  async getObligations(vrn: string, from: string, to: string): Promise<{ obligations: VatObligation[] }> {
    const res = await fetch(
      `${API_BASE}/obligations/${encodeURIComponent(vrn)}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
    );
    if (!res.ok) throw new Error(`Obligations failed: ${res.status}`);
    return res.json();
  },

  async submitReturn(vrn: string, body: VatReturnReq): Promise<any> {
    const res = await fetch(`${API_BASE}/returns/${encodeURIComponent(vrn)}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(`VAT return failed: ${res.status}`);
    return res.json();
  },

  async testFraudHeaders(): Promise<any> {
    const res = await fetch(`${API_BASE}/test-fraud-headers`);
    if (!res.ok) throw new Error(`Fraud header test failed: ${res.status}`);
    return res.json();
  },
};
